/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const s=require("./messages.js");class a{constructor(e){if(this.language=e,e===""&&process.env.NODE_ENV!=="production")throw"Language should not be an empty string"}toLanguageString(e,t){return this.language&&s.messages[this.language]&&s.messages[this.language].hasOwnProperty(e)?s.messages[this.language][e]:t}}exports.LocalizationService=a;
